export const shippingManagerMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/logistics/shipment-management/shipping-providers',
    label: 'Shipment Manager',
    Description: 'Transport Manager is a comprehensive solution that centralizes customer, sales, and agent management, providing a unified platform for efficient and streamlined operations.',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M21 4.5h-1V3h-1.5l-.5-.5H8.5L8 3H6.5l-.5-.5H4.5l-.5.5H2v1.5H1v12h2v-4h18v4h2V6.5h-1V4.5zM3 6h18V4.5H3V6zm0 12v-9h18v9H3z" fill="#007BFF"></path>
            </g>
        </svg>

    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Shipping Providers',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm-7 9h1a6 6 0 1 1 12 0h1a7 7 0 0 1-7 7 7 7 0 0 1-7-7z" />
                    <path fill="#007BFF" d="M6 14a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4h2a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6h2z" />
                </svg>

            ),
            path: '/management/logistics/shipment-management/shipping-providers',
            isEnabled: true,

        },


    ],
}
)
